import appConfig from "../config/appConfig";

export const AppName = "Immosnapp";

// redux actions
export const TOGGLE_DRAWER = Symbol("TOGGLE_DRAWER");
export const TOGGLE_SIDE_NAV = Symbol("TOGGLE_SIDE_NAV");
export const SET_ACTIVE_STATE = Symbol("SET_ACTIVE_STATE");
export const SET_TITLE = Symbol("SET_TITLE");
export const TOGGLE_PROJECT = Symbol("TOGGLE_PROJECT");
// redux actions

export const BASE_URL = `${appConfig.API_URL}/getFile?filePath=`;
// export const BASE_URL = "https://immosnapp.teamjft.com/getFile?filePath=";
export const API_ROOT = appConfig.API_URL;
// export const API_ROOT = 'https://immosnapp.teamjft.com';
export const successSnackBarOptions = {
  position: "bottom-center",
  style: {
    backgroundColor: "#4caf50",
  },
  closeStyle: {
    color: "white",
    fontSize: "14px",
  },
};
export const failSnackBarOptions = {
  position: "bottom-center",
  style: {
    backgroundColor: "#f44336",
  },
  closeStyle: {
    color: "white",
    fontSize: "14px",
  },
};

export function formatName(name, customlength, position, BranchLength) {
  if (name && !customlength) {
    if (name?.length > 20) {
      if (position) {
        return '...' + name.slice((BranchLength > 15 ? (name?.length - 10) : (name?.length - 24)), name?.length).trim()
      }
      else
        return name.slice(0, 20).concat('...').trim()
    }
    else {
      return name?.trim()
    }
  }
  else {
    if (name?.length > customlength) {
      if (position) {
        return '...' + name.slice(0, customlength).trim()
      }
      else
        return name.slice(0, customlength).concat('...').trim()
    }
    else {
      return name?.trim()
    }
  }
}

export function escapeHtml(unsafe) {
  return unsafe
       .replace(/&/g, "&amp;")
       .replace(/</g, "&lt;")
       .replace(/>/g, "&gt;")
       .replace(/"/g, "&quot;")
       .replace(/'/g, "&#039;");
}

export function capitalizeFirstLetter(string) {
  var splitStr = string?.toLowerCase()?.split(' ');
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(' ');
}

export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const goBack = () => window.history.go(-1);

/**
 * Two-character initials for project / group-chat avatar tiles.
 * Prefers letters when present ("Abstimmung Intern" → "AB", "2Users1" → "US").
 * Falls back to digits when the name has no letters ("10:57" → "10").
 */
export function getAvatarInitials(name) {
  if (!name) return "";
  const source = String(name);
  const letters = source.replace(/[^a-zA-Z]/g, "");
  if (letters.length > 0) {
    return letters.substring(0, 2).toUpperCase();
  }
  const digits = source.replace(/[^0-9]/g, "");
  return digits.substring(0, 2);
}



export const KJUUP_COLORS = {
  /** Follows --kjuup-accent: orange by default, purple when Kjuup.io is on. */
  base_color: "var(--kjuup-accent)",
  orange: "#f08438",
  /** Follows --kjuup-internal: green by default, purple when Kjuup.io is on. */
  internal: "var(--kjuup-internal)",
  internalLight: "#fdeee3",
  email: "#e066ed",
}

// Predefined colors for sender names in group chats
const SENDER_COLORS = [
  "#A493E6", // purple (like rgb(164, 147, 230))
  "#4693FD", // blue
  "#E67C73", // red/coral
  "#33B679", // green
  "#F6BF26", // yellow/gold
  "#8E44AD", // dark purple
  "#E91E63", // pink
  "#00ACC1", // cyan
  "#FF7043", // deep orange
  "#7CB342", // light green
  "#5C6BC0", // indigo
  "#26A69A", // teal
];

// Generate a consistent color for a sender based on their ID
export function getSenderColor(senderId) {
  if (!senderId) return SENDER_COLORS[0];
  
  // Generate a hash from the senderId to get a consistent index
  let hash = 0;
  const idString = String(senderId);
  for (let i = 0; i < idString.length; i++) {
    hash = idString.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash; // Convert to 32bit integer
  }
  
  const index = Math.abs(hash) % SENDER_COLORS.length;
  return SENDER_COLORS[index];
}

export function getLightColor(baseColor, lightnessIncrease) {
  // Convert the base color from hex to RGB
  const baseRgb = hexToRgb(baseColor);

  // Increase the RGB values to make the color lighter
  const lightRgb = {
    r: Math.min(255, baseRgb.r + lightnessIncrease),
    g: Math.min(255, baseRgb.g + lightnessIncrease),
    b: Math.min(255, baseRgb.b + lightnessIncrease)
  };

  // Convert the new RGB values back to hex
  const lightHex = rgbToHex(lightRgb.r, lightRgb.g, lightRgb.b);

  return lightHex;
}

export function makeid(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() *
      charactersLength));
  }
  return result;
}

function hexToRgb(hex) {
  const bigint = parseInt(hex.substring(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return { r, g, b };
}

function rgbToHex(r, g, b) {
  const componentToHex = (c) => {
    const hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  };
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

/**
 * Safely extracts the file URL from fileUrl which can be either an array or string.
 * @param {string|string[]} fileUrl - The file URL (can be array or string)
 * @returns {string} - The extracted URL or empty string if invalid
 */
export function getFileUrl(fileUrl) {
  if (!fileUrl) return '';
  if (Array.isArray(fileUrl)) {
    return fileUrl.length > 0 ? fileUrl[0] : '';
  }
  return typeof fileUrl === 'string' ? fileUrl : '';
}

/**
 * Builds a complete image URL for display, handling both local and remote files.
 * @param {boolean} isLocal - Whether the file is local
 * @param {string|string[]} fileUrl - The file URL (can be array or string)
 * @param {string} [attachedFileName] - Optional attached file name
 * @returns {string} - The complete URL for the image
 */
export function buildImageUrl(isLocal, fileUrl, attachedFileName) {
  const url = getFileUrl(fileUrl);
  if (!url) return '';
  if (isLocal) return url;
  if (url.startsWith("blob:") || url.startsWith("data:") || url.startsWith("http")) return url;
  const fileName = attachedFileName ? `&fileName=${encodeURIComponent(attachedFileName)}` : '';
  return `${BASE_URL}${url}${fileName}`;
}